import { IState } from '../IState';

const menuStoreSelector = (state: IState) => state.menu;

const menuStoreMenuSelector = (state: IState) => menuStoreSelector(state).menu;
const menuStoreMenuDataSelector = (state: IState) => menuStoreMenuSelector(state).data;
const menuStoreMenuMetaSelector = (state: IState) => menuStoreMenuSelector(state).meta;

export const menuListSelector = (state: IState) => menuStoreMenuDataSelector(state).list;
export const menuListNetworkStatusSelector = (state: IState) => menuStoreMenuMetaSelector(state).networkStatus;
